import { Box } from '@components/ui/atoms/Box';
import { Flex } from '@components/ui/atoms/Flex';
import { Text } from '@components/ui/atoms/Text';
import { useState } from 'react';

import { dummyNotifications } from '../NotificationModal/dummyData';
import type { Notification } from '../NotificationModal/types';
import { NotificationDetail, NotificationGroup } from './Fields';

const groupNotificationsByTime = (notifications: Notification[]) => {
  const now = Date.now();
  const oneDay = 24 * 60 * 60 * 1000;
  const oneWeek = 7 * oneDay;
  const oneMonth = 30 * oneDay;

  const today: Notification[] = [];
  const thisWeek: Notification[] = [];
  const thisMonth: Notification[] = [];
  const earlier: Notification[] = [];

  notifications.forEach((notification) => {
    const timestamp = new Date(notification.timestamp).getTime();
    const diff = now - timestamp;

    if (diff < oneDay) {
      today.push(notification);
    } else if (diff < oneWeek) {
      thisWeek.push(notification);
    } else if (diff < oneMonth) {
      thisMonth.push(notification);
    } else {
      earlier.push(notification);
    }
  });

  return { today, thisWeek, thisMonth, earlier };
};

export const NotificationListing: React.FC = () => {
  const [selectedNotification, setSelectedNotification] = useState<Notification | null>(
    dummyNotifications[0] || null
  );

  const { today, thisWeek, thisMonth, earlier } = groupNotificationsByTime(dummyNotifications);

  return (
    <Flex h="calc(100vh - 100px)" w="100%" gap="24px" py={4}>
      {/* Left Panel - Notifications List */}
      <Flex
        direction="column"
        gap={4}
        w="450px"
        maxH="full"
        borderRadius="8px"
        borderRight="1px solid"
        borderColor="body.550/10"
        bg="white/60"
        overflowY="auto"
        py={6}
      >
        <Flex px={5} pb={4} borderBottom="1px solid" borderColor="body.550/10">
          <Text fontWeight="600" color="title.dark">
            Notifications
          </Text>
        </Flex>

        {/* Notification Groups */}
        <Box maxH="600px" overflowY="auto">
          <NotificationGroup
            title="Today"
            notifications={today}
            selectedId={selectedNotification?.id ?? null}
            onSelectNotification={setSelectedNotification}
          />
          <NotificationGroup
            title="This Week"
            notifications={thisWeek}
            selectedId={selectedNotification?.id ?? null}
            onSelectNotification={setSelectedNotification}
          />
          <NotificationGroup
            title="This Month"
            notifications={thisMonth}
            selectedId={selectedNotification?.id ?? null}
            onSelectNotification={setSelectedNotification}
          />
          <NotificationGroup
            title="Earlier"
            notifications={earlier}
            selectedId={selectedNotification?.id ?? null}
            onSelectNotification={setSelectedNotification}
          />
        </Box>
      </Flex>

      {/* Right Panel - Notification Detail */}
      <NotificationDetail notification={selectedNotification} />
    </Flex>
  );
};
